import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { removeCartItem } from "../../actions/payments/cartActions";

export default function CartActivity({item, index}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    
    // Función auxiliar getPrice similar a la que se usa en Description.js y Group.js
    const getPrice = (price) => {
        if (price && !isNaN(price)) {
            const activity = item.commission?.find(activity => price >= activity.lowPrice && price <= activity.highPrice);
            if (activity) {
                return price > 0 ? (price + (Math.ceil(((price * (activity.percentage || 0) / 100) + (activity.double || 0)) * 100) / 100)).toFixed(2) : parseFloat(price).toFixed(2)
            } else {
                return parseFloat(price).toFixed(2)
            }
        } else {
            return '0.00'
        }
    }

    const calculateActivityPrice = (item) => {
        // Obtener la matrícula
        let registrationPayment = 0
        if (item.group.registrationPayment?.maxdate && new Date(item.group.registrationPayment?.maxdate) >= new Date()) {
            registrationPayment = parseFloat(item.group.registrationPayment.price)
        }
        
        // Calcular el impacto de las respuestas a las preguntas sobre la matrícula
        const registrationImpact = item.questions
        .reduce((sum, question) => {
            const registrationPercentageTotal = (parseFloat(registrationPayment) * ((parseFloat(question?.impact?.registrationPercentage || 0)) / 100))
            return parseFloat(sum) + (parseFloat(registrationPercentageTotal)) + (question?.impact?.registrationQuantity || 0);
        }, 0)
        
        // Obtener todos los pagos de temporada
        const allSeasonPayments = item.group.seasonPayments || [];
        
        // Calcular el precio total de todos los pagos de temporada con impactos
        let totalSeasonPaymentsWithImpact = 0;
        
        allSeasonPayments.forEach(payment => {
            const paymentImpact = item.questions
            .reduce((questionTotal, question) => {
                const seasonPaymentPercentageTotal = (parseFloat(payment.price) * ((parseFloat(question?.impact?.seasonPaymentPercentage || 0)) / 100));
                return parseFloat(questionTotal) + (parseFloat(seasonPaymentPercentageTotal)) + (question?.impact?.seasonPaymentQuantity || 0);
            }, 0);
            
            totalSeasonPaymentsWithImpact += parseFloat(paymentImpact) + parseFloat(payment.price);
        });
        
        // Aplicar promociones si existen
        if (item.promotions) {
            // Este código se mantiene por compatibilidad, pero utiliza los resultados finales
            // para el cálculo correcto con getPrice
        }
        
        // Calculamos el precio de la matrícula más el impacto con comisión
        const registrationPaymentWithImpactAndCommission = parseFloat(getPrice(registrationPayment + registrationImpact));
        
        // Luego calculamos el precio total de los pagos de temporada con impactos y comisión
        const seasonPaymentsWithImpactAndCommission = parseFloat(getPrice(totalSeasonPaymentsWithImpact));
        
        // El precio total es la suma de ambos con 2 decimales
        const totalPriceWithCommission = (registrationPaymentWithImpactAndCommission + seasonPaymentsWithImpactAndCommission).toFixed(2);
        
        return totalPriceWithCommission;
    }

    return (
        <Row className="my-3 cart-item">
            <Col xs={12} md={4}>
                <img src={item.activity.image || `/images/sports/${item.activity?.sport}.jpg`} alt={item.activity.title} className="w-100"/>
            </Col>
            <Col xs={12} md={8} className="d-flex justify-content-between align-items-center">
                <div className="data">
                    <h3 className="font-single mb-1">{item.activity.title}</h3>
                    <p className="club">{item.club.name}</p>
                    <p>{item.group.title}</p>
                    <p>{item.client.lastname}, {item.client.firstname}</p>

                    {item?.group?.assignableHorary ?
                        <p>{t('cart.horary')}: {item.group.horaries.find(g => g._id === item.horary)?.name}</p>
                    :
                        ''
                    }
                    <p className="fw-bold">
                        {t('marketplace.activity.total')}: {calculateActivityPrice(item)}€
                        {item.group.verify && <span className="ms-2 small text-muted">(Pendiente autorización del club)</span>}
                    </p>
                </div>
                <div className="icons">
                    <img src="/images/trash.svg" alt="trash" className="cursor" width={15} onClick={() => {dispatch(removeCartItem(index))}}/>
                </div>
            </Col>
        </Row>
    )
}